import { Component, OnInit, OnDestroy } from "@angular/core";
import { ProjectsService } from "./projects.service";
import { errorTypes } from "./projects.service";
import { Router } from "@angular/router";

@Component({
  selector: "createproject-component",
  template: require('./createproject.component.html'),
  styles: [require('./createproject.component.scss')]
})
export class CreateProjectComponent implements OnInit, OnDestroy {
  project: any = {
    active: true,
    client: {},
    supervisors: [],
    suppliers: [{ active: false }]
  };
  companies: any[];
  countries: any[] = [{ name: "Countries", code: null }];
  activePanels: string[] = ["details", "supervisors", "suppliers"];
  companyId: string;
  supplierId: string;
  _companyFields = {
    supervisors: "supervisors",
    suppliers: "suppliers"
  };
  sent: boolean = false;
  projectCodeError: boolean = false;

  constructor(private service: ProjectsService, private router: Router) {
    // Do stuff
  }

  ngOnInit() {
    this.getCompanies();
    this.getCountries();
  }

  ngOnDestroy() {
    this.companies.map((it) => {
      it.isSelected = false;
    });
  }

  getCompanies() {
    this.service.getCompanies().subscribe((companies) => {
      this.companies = companies;
    });
  }

  getCountries() {
    let nations = this.service.getNationalities();
    this.countries = this.countries.concat(nations);
  }

  addCompany(companyId: string, type: string) {
    this.project[type].push({ company_id: companyId });
    if (type === this._companyFields.supervisors) {
      this.companyId = null;
    } else if (type === this._companyFields.suppliers) {
      this.supplierId = null;
    }
  }

  hasCompany(companyId: string, type: string) {
    return this.project[type].filter((it) => {
      return it.company_id === companyId;
    })[0];
  }

  getCompanyName(companyId: string): string {
    return this.companies.filter((item) => {
      return item.id === companyId;
    })[0].name;
  }

  removeListItem(id: string, field: string) {
    let array = this.project[field];
    let index = array.findIndex((it) => it.company_id === id);
    if (index > -1) {
      array.splice(index, 1);
    }
  }

  back() {
    window.history.back();
  }

  isValid() {
    return !this.sent;
  }

  needSupervisorError() {
    return this.project.supervisors.length < 1;
  }

  needSupplierError() {
    return this.project.suppliers.length < 1;
  }

  onSubmit() {
    this.activePanels = [];
    this.projectCodeError = false;
    if (
      this.project.supervisors.length > 0 &&
      this.project.suppliers.length > 0
    ) {
      setTimeout(() => {
        this.save();
      }, 1);
    } else {
      setTimeout(() => {
        this.activePanels = ["details", "supervisors", "suppliers"];
      }, 1);
    }
  }

  save() {
    if (!this.sent) {
      this.sent = true;
      this.removeSelectedSuppliers(this.project);
      this.service.createProject(this.project).subscribe(
        (response) => {
          this.back();
        },
        (error) => {
          this.addSelectedSuppliers(this.project);
          this.activePanels = ["details", "supervisors", "suppliers"];
          this.sent = false;
          this.projectCodeError =
            error.errorType === errorTypes.usedProjectCode;
        }
      );
    }
  }

  removeSelectedSuppliers(company: any) {
    if (company.suppliers) {
      company.suppliers.map((it) => {
        delete it.selectedSupplier;
        this.removeSelectedSuppliers(it);
      });
    }
  }

  addSelectedSuppliers(company: any) {
    if (company.suppliers) {
      company.suppliers.map((supplier) => {
        this.companies.map((item) => {
          if (item.id === supplier.company_id) {
            supplier.selectedSupplier = item;
            return;
          }
        });
        this.addSelectedSuppliers(supplier);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/projects/createproject.component.ts